@if (inline) {
    <div class="w-full min-w-0">
        @if (unit) {
            <p-inputgroup class="w-full">
                <p-inputNumber (onFocus)="$any($event.target)?.select()" class="w-full" [id]="id" [formControl]="control" [minFractionDigits]="resolvedMinFractionDigits" [maxFractionDigits]="resolvedDecimals" [invalid]="isGrid && control.invalid && control.touched"/>
                <p-inputgroup-addon class="whitespace-nowrap shrink-0">{{unit}}</p-inputgroup-addon>
            </p-inputgroup>
        } @else {
            <p-inputNumber (onFocus)="$any($event.target)?.select()" class="w-full" [id]="id" [formControl]="control" [minFractionDigits]="resolvedMinFractionDigits" [maxFractionDigits]="resolvedDecimals" [invalid]="isGrid && control.invalid && control.touched"/>
        }

        @if (showValidation && control.invalid && control.touched && !isGrid) {
            <label class="validation-error">{{getValidationMessage()}}</label>
        }
    </div>
} @else {
    <div class="w-full min-w-0">
        @if (label) {
            <label [for]="id" class="block">{{label}}</label>
        }

        @if (unit) {
            <p-inputgroup class="w-full">
                <p-inputNumber (onFocus)="$any($event.target)?.select()" class="w-full" [id]="id" [formControl]="control" [minFractionDigits]="resolvedMinFractionDigits" [maxFractionDigits]="resolvedDecimals" [invalid]="isGrid && control.invalid && control.touched"/>
                <p-inputgroup-addon class="whitespace-nowrap shrink-0">{{unit}}</p-inputgroup-addon>
            </p-inputgroup>
        } @else {
            <p-inputNumber class="w-full" [id]="id" [formControl]="control" [minFractionDigits]="resolvedMinFractionDigits" [maxFractionDigits]="resolvedDecimals" [invalid]="isGrid && control.invalid && control.touched"/>
        }

        @if (showValidation && control.invalid && control.touched && !isGrid) {
            <label class="validation-error">{{getValidationMessage()}}</label>
        }
    </div>
}